// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IfbHRUeu2tAaMJ {
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-height: 36px;
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
.IfbHRUeu2tAaMJ p {
  margin: var(--ds-space-100, 8px) var(--ds-space-150, 12px);
}
`, ""]);
// Exports
export var mirrorCardNotFound = `IfbHRUeu2tAaMJ`;
export default ___CSS_LOADER_EXPORT___;
